import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  message,
} from 'antd';
import * as qs from 'query-string';
import { Link, Redirect } from 'react-router-dom';

import { Spinner } from '../../UI';
import { Logo } from '../../Page';

import styles from './Confirm.module.css';

const { Title, Text } = Typography;

message.config({
  top: 12,
  duration: 3
});

class Confirm extends Component {

  componentDidMount () {
    const { location } = this.props;
    const parsed = qs.parse(location.search);
    const token = parsed.h;
    const payload = { token };

    setTimeout(() => this.props.confirm(payload, () => this.success('You are logged in!')), 800);
  }

  success = (msg) => {
    message.success(msg);
  };

  render() {
    const {
      protocol,
      hostname
    } = window.location;
    const logo = `${protocol}//${hostname}/logo/${hostname}/logo.png`;

    if (this.props.isAuthenticated) {
      return <Redirect to="/reports/overview" />
    }

    const message = this.props.pageLoading ? <Spinner /> : <Text type="danger">{this.props.error} Please <Link to="/signup">sign up</Link> once more.</Text>;

    return (
      <div className={styles.confirm}>
        <Logo
          src={logo}
          alt=""
        />
        <Title>Account Confirmation</Title>
        {message}
      </div>
    );
  }
}

Confirm.propTypes = {
  confirm: PropTypes.func.isRequired,
  pageLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};

export default Confirm;

